<template>

  <div id="policy-container">
    <label for="policy" v-show="showAgreeBeforeBookingPolicy">
      By making this booking you agree to the
      <span v-if="hasTermsAndConditions">
        <a href="#" :data-reveal-id="policies.terms.key" @click.prevent="openModal(policies.terms.key)">Terms and Conditions</a>
        <span v-if="hasPrivacyPolicy">
          and
        </span>
      </span>
      <span v-if="hasPrivacyPolicy">
        <a href="#" :data-reveal-id="policies.privacy.key" @click.prevent="openModal(policies.privacy.key)">Privacy Policy.</a>
      </span>
    </label>

    <div :id="policies.terms.key"  class="reveal-modal small" data-reveal aria-labelledby="termsAndConditionsModal" aria-hidden="true" role="dialog" v-if="hasTermsAndConditions">
      <h5 >Terms &amp; Conditions</h5>
      <hr />
      <p v-html="termsAndConditionsPolicy">
      </p>
      <a class="close-reveal-modal" aria-label="Close">&#215;</a>
    </div>
    <div :id="policies.privacy.key" class="reveal-modal small" data-reveal aria-labelledby="privacyModal" aria-hidden="true" role="dialog" v-if="hasPrivacyPolicy">
      <h5> Privacy Policy</h5>
      <hr />
      <p v-html="privacyPolicy"></p>
      <a class="close-reveal-modal" aria-label="Close">&#215;</a>
    </div>

  </div>

</template>

<script>
import { getTermsAndConditionsPolicy, getPrivacyPolicy } from './policy-api';

export default {
  name: 'AgreeBeforeBooking',
  data() {
    return {
      policies: {
        terms: {
          key: 'terms-and-conditions',
          value: '',
        },
        privacy: {
          key: 'privacy-policy',
          value: '',

        },
      },
    };
  },

  computed: {
    termsAndConditionsPolicy() {
      return this.policies.terms.value ? this.policies.terms.value : '';
    },
    privacyPolicy() {
      return this.policies.privacy.value ? this.policies.privacy.value : '';
    },
    hasTermsAndConditions() {
      return this.termsAndConditionsPolicy.length > 0;
    },
    hasPrivacyPolicy() {
      return this.privacyPolicy.length > 0;
    },
    showAgreeBeforeBookingPolicy() {
      return this.hasTermsAndConditions || this.hasPrivacyPolicy;
    },
  },

  methods: {
    async getTermsAndConditionsPolicy() {
      const { data } = await getTermsAndConditionsPolicy();
      this.policies.terms.value = data;
    },

    async getPrivacyPolicy() {
      const { data } = await getPrivacyPolicy();
      this.policies.privacy.value = data;
    },

    openModal(key) {
      // Remove dependency on jQuery asap
      $(`#${key}`).foundation('reveal', 'open');
    },
  },

  beforeMount() {
    this.getTermsAndConditionsPolicy();
    this.getPrivacyPolicy();
  },
};
</script>

<style scoped>

#policy-container {
  padding: 0 24px 0 24px;
}

</style>
